import { CompanyDocumentsShow } from '@Resources/companies/documents/CompanyDocumentsShow';
import { ResourceDefinition } from '@Utils/types';

export const companiesDocumentsResource: ResourceDefinition = {
  options: { label: 'menu.documents' },
  show: CompanyDocumentsShow,
};
